// extracted by mini-css-extract-plugin
module.exports = {"trailer":"hV","imgWrapper":"hW","thumbnail":"hX","isRental":"hY","playWrapper":"hZ","playImg":"h0","title":"h1","iconWrapper":"h2","navArrow":"h3"};